import { render, staticRenderFns } from "./DetailCustomerDialog.vue?vue&type=template&id=269dbb26&scoped=true&class=scroll-disable"
import script from "./DetailCustomerDialog.vue?vue&type=script&lang=js"
export * from "./DetailCustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269dbb26",
  null
  
)

export default component.exports